<template>
  <div class="container">
    <QueryFrame
      add-text=""
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>付款方式名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 编辑出层 开始 -->
    <lk-modal
      v-model="editModal.visiable"
      :mask-closable="false"
      title="编辑"
      @on-cancel="cancelEdit">
      <lk-form
        label-position="right"
        :label-width="134"
        :rules="formRules"
        :model="formModel"
        ref="form">
        <div class="modalContainer">
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="付款方式:" prop="proceedsTypeName">
                <span>{{formModel.proceedsTypeName}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="排序:" prop="sort">
                <lk-input-number
                  style="width: 100%"
                  :precision="0"
                  :active-change="false"
                  :min='1'
                  v-model="formModel.sort">
                </lk-input-number>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelEdit">取消</lk-button>
          <lk-button type="primary" @click="handleSave" :loading="editModal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 编辑出层 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import systemService from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'storeProceedsType',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      query: {
        name: '',
      },
      editModal: {
        visiable: false,
        loading: false,
      },
      formModel: {
        id: '',
        proceedsTypeName: '',
      },
      formRules: {
        sort: [
          { required: true, message: '请输入排序数字' },
        ],
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '付款方式名称',
          key: 'proceedsTypeName',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => (this.hasEditable ? h('lk-switch', {
            props: {
              size: 'large',
              value: row.status === 1,
              loading: row.loading,
            },
            on: {
              'on-change': (value) => {
                const finalFn = value ? systemService.setStoreProceedsTypeEnable : systemService.setStoreProceedsTypeDisable;
                row.loading = true;
                finalFn({
                  id: row.id,
                  proceedsTypeId: row.proceedsTypeId,
                  proceedsTypeName: row.proceedsTypeName,
                  storeId: row.storeId
                }).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success(value ? '该付款方式已启用' : '该付款方式已禁用');
                    row.status = value ? 1 : 2;
                  } else {
                    this.$Message.error(res.data.error);
                    this.getData();
                  }
                  row.loading = false;
                }).catch((err) => {
                  utils.handleError(err);
                });
              },
            },
          }, [
            h('span', {
              slot: 'open',
            }, '启用'),
            h('span', {
              slot: 'close',
            }, '禁用'),
          ]) : h('span', row.status === 1 ? '启用' : '禁用')),
        },
        {
          title: '显示序号',
          key: 'sort',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.hasEditable ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.formModel.id = row.id;
                  this.formModel.sort = row.sort;
                  this.formModel.proceedsTypeName = row.proceedsTypeName;
                  this.editModal.visiable = true;
                },
              },
            }, '编辑') : '',
          ]),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('storeProceedsTypeEdit');
    },
  },
  methods: {
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.createTime) {
        this.params.createTime = new Date(this.params.createTime).getTime();
      }

      systemService.getStoreProceedsTypeList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          const params = {
            id: this.formModel.id,
            sort: this.formModel.sort,
          };

          this.editModal.loading = true;
          systemService.proceedsTypeUpdate(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.editModal.visiable = false;
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
            this.editModal.loading = false;
          }).catch((err) => {
            this.editModal.loading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    handleReset() {
      this.query = {};
    },
    cancelEdit() {
      this.$refs.form.resetFields();
      this.editModal.visiable = false;
    },
  },
  created() {
    this.handleSearch(true);
    if (!this.hasEditable) {
      this.columns.pop();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
